const all_product = [
    { id:1, name: 'Smartphone', new_price: 499, old_price: 599, image: 'products/quamer.jpeg', category: "men"},
    { id:2, name: 'Laptop', new_price: 899, old_price: 999, image: 'products/quamer.jpeg', category: "men"},
    { id:3, name: 'Headphones', new_price:199, old_price: 299, image: 'products/quamer.jpeg', category: "men"},
    { id:4, name: 'Swiss', new_price: 199, old_price: 299, image: 'products/p1.jpeg', category: "men" },
    { id:5, name: 'Headphones', new_price: 19, old_price: 299, image: 'products/p2.jpeg', category: "kid"},
    { id:6, name: 'Headphones', new_price: 19, old_price: 299, image: 'products/p3.jpeg', category: "women"},
    { id:7, name: 'Headphones', new_price: 199, old_price: 299, image: 'products/p4.jpeg', category: "kid" },
    { id:8, name: 'Headphones', new_price: 199, old_price: 299, image: 'products/p5.jpeg', category: "women" },
    { id:9, name: 'Headphones', new_price: 199, old_price: 299, image: 'products/p6.jpeg', category: "kid" },
    { id:10, name: 'Headphones', new_price: 199, old_price: 299, image: 'products/p7.jpeg', category: "women" },
    { id:11, name: 'Headphones', new_price: 199, old_price: 299, image: 'products/p8.jpeg', category: "men" },
]


let cartItem = [
]


export {
    cartItem,
    all_product
}